export const extractValueAndUnit = (input) => {
	const regex = /^([\d.]+)(px|em|rem|%)$/ // Matches numeric values with units
	const match = input.match(regex)

	if (match) {
		const value = parseFloat(match[1]) // Convert numeric part to a number
		const unit = match[2] // Extract unit part
		return { value, unit }
	}

	return { value: 0, unit: 'px' } // Default value
}